'use client'
import React from 'react'
import { FieldRenderProps } from 'react-final-form'
import styles from './stylers.module.scss'

interface RadioButtonProps extends FieldRenderProps<string, HTMLElement> {
  label: string
}

const InputRadiobox: React.FC<RadioButtonProps> = ({ label, id, input }) => {
  return (
    <div>
      <label className={`${styles.label}`} htmlFor={id}>
        {label}
        <input type="radio" id={id} {...input} />
        <span />
      </label>
    </div>
  )
}

export default InputRadiobox
